import { gql } from "@apollo/client";

export const DEACTIVATE_ADDON_RATE_CARD = gql`
  mutation deactivateAddonRateCard($id: String!, $activate: Boolean) {
    deactivateAddonRateCard(id: $id, activate: $activate) {
      id
      name
      isActive
      isDefault
      displayName
      dateUpdated
      lastUpdatedBy {
        firstName
        lastName
      }
      businessCustomers {
        businessName
        id
      }
      addons {
        name
        pricing {
          rangeStart
          rangeEnd
          unitPrice
        }
        addon {
          id
          name
        }
      }
    }
  }
`;
